'use strict';

angular.module('webAgro1App').service('FuncaoObjectService', function(filterFilter) {
  return {
    convertToSend: function(funcao) {
      var result = {
        id: funcao.id || null,
        descricao: funcao.descricao
      };

      var itens = [];
      for (var i = funcao.modulos.length - 1; i >= 0; i--) {
        var modulo = funcao.modulos[i];
        var filterItens = (modulo.itens || []).map(function(item) {
          var acoes = (filterFilter(item.acoes, {permitir: true}, true) || []).map(function(acao) {
            return acao.id;
          });

          if (acoes.length > 0) {
            return {
              id: item.idRegistro || null,
              modulo_id: modulo.id,
              modulo_item_id: item.id,
              acoes: acoes
            };
          }
        });
        itens = itens.concat(filterItens.filter(Boolean));
      }
      result.itens_attributes = itens;

      return result;
    },

    convertToObject: function(modulos, funcao) {
      if (!funcao) {
        return;
      }

      modulos = (modulos || []).map(function(modulo) {
        modulo.itens = modulo.itens.map(function(item) {
          var itemPermissoes = filterFilter(funcao.permissions, {id: item.id}, true)[0] || {};
          if (itemPermissoes.acoes) {
            item.acoes = item.acoes.map(function(acao) {
              acao.permitir = itemPermissoes.acoes.indexOf(acao.id) >= 0;
              return acao;
            });
          }
          return item;
        });
        return modulo;
      });

      return {
        id: funcao.id || null,
        descricao: funcao.descricao || null,
        modulos: modulos
      };
    }
  };
});
